export interface TrendingVideoItem {
  videoId: string;
  videoUrl: string;
  videoPath: string;
  productFocus: string;
  productLink: string;
  productSlug: string;
  contentLink?: string;
  order: number;
  isVisible: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface ListTrendingVideosResponse {
  videos: TrendingVideoItem[];
}

export interface ListTrendingVideosRequest {
  visibleOnly?: boolean;
  limit?: number;
}
